export default __webpack_public_path__ + "static/char-v-06-8423faa8b5d9df54c46c43560ae4ee42.mp4";